import React, { FC, useState } from "react";
import { Tree } from "./checkbox-tree2";

interface CheckboxNode2Props {
    tree: Tree;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, node: Tree) => void
}

const CheckboxNode2: FC<CheckboxNode2Props> = ({ tree, onChange }) => {
    const [expand, setExpand] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    const onExpand = () => {
        setExpand(exp => !exp);
        setCollapsed(collapsed => !collapsed);
    }
    
    return <div className="border-l">
        <div className="flex">
            <svg onClick={onExpand} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${tree.children && tree.children.length > 0 ? '' : 'invisible'} w-6 h-5  cursor-pointer transform transition-transform duration-300 ${expand === false ? "rotate-360" : "rotate-90"}`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
            {tree.clickable ? <input type="checkbox" className="ml-1 mr-3" checked={tree.checked} onChange={(e) => onChange(e, tree)} /> : null}
            <span>{tree?.label}</span>

        </div>
        {collapsed ? tree?.children?.map((child, i) => {
            return <div key={child.id} className="ml-3">
                <CheckboxNode2 tree={child} onChange={onChange} />
            </div>
        }) : null}
    </div>
}

export default CheckboxNode2;